module.exports = __webpack_public_path__ + "img/best-price-en-m.7867cb3.webp";